import { Card, Grid } from '@material-ui/core';
import TableGeneric from '../../../compartidos/abms/TableGeneric';
import { useSelector } from 'react-redux';
import { useTotemBasic } from '../../../../hooks/useCases/useTotemBasic';
import { useEffect } from 'react';
import Select from "react-select";

export const AbmOpcionesPorBox = () => {
  const { boxes, opciones } = useSelector(state => state.totemBasic)
  const { get, insert } = useTotemBasic()
  useEffect(() => {
    get.opciones()
    get.boxes()
  }, [])
  return (
    <>
      <Grid container spacing={2} justify='center' style={{ padding: 10, marginTop: 2 }}>
        <Grid item xs={9} component={Card} >
          <TableGeneric
            align="center"
            data={boxes}
            columns={[
              {
                label: "Box",
                id: "descripcion",
              },
              {
                label: "Opciones",
                minWidth: "10vh",
                maxWidth: "10vh",
                customBody: (item) => (
                  <Select
                    onChange={(e) => insert.opcionPorBox({ idsOpciones: e.map(opcion => opcion.value), idBox: item.id })}
                    value={
                      item.opcionesPorBoxes.map((opcionBox) => {
                        const opcion = opciones.find(
                          (e) => e.id === opcionBox.idOpcion
                        );
                        return opcion
                          ? {
                            value: opcion.id,
                            label: opcion.descripcion,
                          }
                          : undefined;
                      }) ?? []
                    }
                    isMulti
                    name="colors"
                    options={opciones.map((opcion) => ({ value: opcion.id, label: opcion.descripcion }))}
                    placeholder="Seleccione Opciones Para El Box..."
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                    menuPosition="fixed"
                    fullWidth
                  />)
              },
            ]}
          />
        </Grid>
      </Grid>
    </>
  )
}
